/**
 * 뒤로가지 할 때 이전 스크롤 위치로 복원하기 위해 만듬.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type Props = {
    /** 특정 경로만 복원하고 싶으면 여기서 필터링 */
    enabled?: boolean;
};

export default function ScrollRestoration({ enabled = true }: Props) {
    const location = useLocation();

    useEffect(() => {
        if (!enabled) return;

        // 브라우저가 자동 복원하지 않도록 설정
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }

        const key = `scroll:${location.key}`;
        const saved = sessionStorage.getItem(key);

        if (saved) {
            const y = Number(saved);
            if (Number.isFinite(y)) window.scrollTo(0, y);
        } else {
            // 새 페이지 이동은 맨 위 (원하면 제거 가능)
            window.scrollTo(0, 0);
        }

        const onScroll = () => {
            sessionStorage.setItem(key, String(window.scrollY));
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, [location.key, enabled]);

    return null;
}
